import type { IBundlePackage, IInternetPackage } from '~/src/services/api/api-content/cities/types';
import type { IFormattedTariff } from '~/src/services/tariffs/types';

export const formatTariff = (tariff: IInternetPackage | IBundlePackage): IFormattedTariff => {
    return {
        tariffId: tariff.tariff_id,
        description: {
            tariff_id: tariff.description.tariff_id ? tariff.description.tariff_id : tariff.description.sale_package_id,
            title: tariff.description.title,
            description: tariff.description.description,
            alias: tariff.description.alias,
        },
        speed: 'speed' in tariff ? tariff.speed : tariff.speed_int,
        channelCount: 'channelCount' in tariff ? tariff.channelCount : null,
        price: 'price' in tariff ? tariff.price : tariff.price2in1,
        pricePromo: 'price_promo' in tariff ? tariff.price_promo : tariff.promo_price2in1,
        priceIncludedVas: 'price_included_vas' in tariff ? tariff.price_included_vas : null,
        additionalProducts: [...tariff.additionalProducts],
        cityId: tariff.city_id,
        hasRequiredEquipment: tariff.hasRequiredEquipment,
        isCottage: 'is_cottage' in tariff ? !!tariff.is_cottage : !!tariff.salePackage2in1?.is_cottage,
        promoPriceFinal: 'salePackage2in1' in tariff ? tariff.salePackage2in1.promo_price_final : tariff.promo_price_final,
        priceFinal: 'salePackage2in1' in tariff ? tariff.salePackage2in1.price_final : tariff.price_final,
        tariffName: 'tariff_name_display' in tariff ? tariff.tariff_name_display : tariff.tariff_name,
        isAvailableForPromotion: 'salePackage2in1' in tariff ? !!tariff.salePackage2in1.is_available_for_promotion : false,
        promoDurationFinal: 'salePackage2in1' in tariff ? tariff.salePackage2in1.promo_duration_final : 0,
        salePackageLinks: tariff.salePackageLinks,
        // Костыль, связанный с frontend/src/services/tariffs/types.ts:28
        // также связанные места - frontend/src/services/tariffs/formatTariff.ts
        alias: tariff.description.alias,
    };
};
